import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'ar', label: 'العربية' },
];

export default function LanguageSwitcher({ size = 'medium', showLabel = false, sx }) {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const currentLang = i18n.language?.split('-')[0] || 'en';
  const currentLabel = LANGUAGE_OPTIONS.find(o => o.code === currentLang)?.label || 'English';

  const handleChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setAnchorEl(null);
  };

  return (
    <>
      {showLabel ? (
        <Button
          startIcon={<LanguageIcon />}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={sx}
        >
          {currentLabel}
        </Button>
      ) : (
        <Tooltip title="Language">
          <IconButton
            size={size}
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={sx}
          >
            <LanguageIcon fontSize={size === 'small' ? 'small' : 'medium'} />
          </IconButton>
        </Tooltip>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {LANGUAGE_OPTIONS.map(({ code, label }) => (
          <MenuItem
            key={code}
            onClick={() => handleChange(code)}
            selected={currentLang === code}
            dense
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
